import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DecoratorCard from '../components/Decorators/DecoratorCard';
import SEOHead from '../components/SEOHead';
import { decoratorAPI } from '../utils/api';
import './DecoratorsPage.css';

export default function PhotographersPage() {
  const { city } = useParams();
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    const run = async () => {
      setLoading(true);
      try {
        const { data } = await decoratorAPI.getAll({
          vendorType: 'photographer',
          city: city ? city.charAt(0).toUpperCase() + city.slice(1).toLowerCase() : undefined,
          verified: true,
          sort: 'rating',
          limit: 24
        });
        setItems(data.decorators || []);
      } catch (e) {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [city]);

  const cityTitle = city ? city.charAt(0).toUpperCase() + city.slice(1).toLowerCase() : 'Chhattisgarh';

  return (
    <div className="dp-page">
      <SEOHead
        title={`Top Wedding Photographers in ${cityTitle} | DecorHub`}
        description={`Book verified photographers in ${cityTitle}. Compare portfolio, pricing and reviews on DecorHub.`}
        keywords={`photographers ${cityTitle}, wedding photographer ${cityTitle}, best photographer near me ${cityTitle}`}
        canonicalPath={city ? `/photographers/${city.toLowerCase()}` : '/photographers'}
      />

      <div className="dp-container">
        <section className="dp-hero" style={{ marginBottom: 24 }}>
          <h1 className="dp-hero-title">Top <em>Photographers</em> in {cityTitle}</h1>
          <p className="dp-hero-sub">Verified profiles, real reviews aur quick booking.</p>
        </section>

        {loading ? <p>Loading photographers...</p> : (
          <div className="dp-grid v3">
            {items.map((d) => (
              <DecoratorCard key={d._id} decorator={d} />
            ))}
          </div>
        )}

        {!loading && items.length === 0 && (
          <div className="dp-empty"><h3>No photographers found.</h3></div>
        )}
      </div>
    </div>
  );
}
